export default __webpack_public_path__ + "static/media/polygon-bg.14d6c26b.png";